'use strict';

$ = jQuery;

/*
* Evento de clique na logo do Patrocinador do Catálogo
*/
$('.jc-sponsor-logo').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Patrocinador - Logo',
    'eventLabel': $(this).attr('alt')
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Patrocinador - Logo',
    'eventLabel': $(this).attr('alt')
  });
});